import { render, staticRenderFns } from "./SingleGroupDataTable.vue?vue&type=template&id=6291f558&scoped=true"
import script from "./SingleGroupDataTable.vue?vue&type=script&lang=js"
export * from "./SingleGroupDataTable.vue?vue&type=script&lang=js"
import style0 from "./SingleGroupDataTable.vue?vue&type=style&index=0&id=6291f558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6291f558",
  null
  
)

export default component.exports